export default function Footer() {
  return (
    <footer className="bg-[#fafafa] py-12 sm:py-16 md:py-20 border-t border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-16 xl:px-24">
        <div className="flex flex-col items-center space-y-6 sm:space-y-8">
          <div className="mb-4 sm:mb-6">
            <img
              src="https://static.readdy.ai/image/80932669f31e28b86429da114025ac51/08dec07d3c53a8364cfccdbeb3d31cd3.png"
              alt="Naturi"
              className="h-48 sm:h-64 md:h-80 lg:h-96 w-auto"
            />
          </div>

          <div className="text-center space-y-2 sm:space-y-3">
            <p className="text-[0.8rem] sm:text-sm md:text-base text-[#333333] tracking-wide">合同会社Naturi</p>
            <p className="text-[0.75rem] sm:text-sm md:text-base text-[#666666] leading-relaxed tracking-wide">
              〒107-0061<br />
              東京都港区北青山一丁目3番1号<span className="whitespace-nowrap">アールキューブ青山3階</span>
            </p>
          </div>

          <div className="pt-6 sm:pt-8 border-t border-gray-200 w-full">
            <p className="text-center text-[0.7rem] sm:text-xs md:text-sm text-[#888888] tracking-wide">
              © 2024 Naturi LLC. All rights reserved. |{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#6b8e6b] transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
